
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { EntitlementRoleManagemtParametersResponse } from '../entities/entitlements-role-management-v1/management-roles-parameters';
import { axiosInstance } from "../axios-instance";

class EntitlementsRoleManagement {
    private baseUrl: string;

    private client: OAuth2Client | null;

    constructor(baseUrl: string, client: OAuth2Client | null) {
        this.baseUrl = baseUrl;
        this.client = client;
    }

    getEntitlementRoleManagements(): Promise<AxiosResponse<EntitlementRoleManagemtParametersResponse>> {
        const accessToken = localStorage.getItem('accessToken');
        return axiosInstance.get<EntitlementRoleManagemtParametersResponse>(`${this.baseUrl}/parties/CAT/roles`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
    }
}

export default EntitlementsRoleManagement;
